import { z } from 'zod'

import type { SingleFieldEditFormProps } from './type'

import {
  UButton,
  UCard,
  UFormControlInput,
  USkeleton,
  UStack,
  UText,
} from '@src/components'

export const SingleFieldEditForm = <T extends z.ZodTypeAny>({
  currentValue,
  onSubmit,
  currentFieldProps,
  newFieldProps,
  newFieldError,
  fieldConfig,
  displayText,
  isLoading,
  isButtonDisabled,
}: SingleFieldEditFormProps<T>) => {
  const { currentName: _currentName, newName } = fieldConfig
  const {
    title,
    currentLabel,
    newLabel,
    placeholder,
    submitLabel = '変更',
    helperText,
  } = displayText

  return (
    <UCard>
      <form onSubmit={onSubmit}>
        <UStack spacing={3}>
          <UText variant="title2">{title}</UText>
          <div>
            {isLoading ? (
              <USkeleton height="56px" />
            ) : (
              <UFormControlInput
                fullWidth
                label={currentLabel}
                uInputProps={{
                  ...currentFieldProps,
                  value: currentValue,
                  disabled: true,
                }}
              />
            )}
          </div>
          <div>
            <UFormControlInput
              fullWidth
              label={newLabel}
              error={!!newFieldError}
              htmlFor={newName}
              required
              uInputProps={{
                ...newFieldProps,
                placeholder,
                helperText: newFieldError ?? helperText,
              }}
            />
          </div>
          <UButton
            fullWidth
            type="submit"
            color="primary"
            variant="contained"
            disabled={isButtonDisabled}
          >
            {submitLabel}
          </UButton>
        </UStack>
      </form>
    </UCard>
  )
}
